import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';
import { BodyCellRenderResult, Column, formatValue, RowTypeBase } from '@qre-mailing/smart-table';

export enum PhoneColumnStatus {
  INVALID = 'invalid',
  VERIFIED = 'verified',
  BLACKLISTED = 'blacklisted',
  CHECKING = 'checking',
  DISCARDED = 'discarded',
  EXHAUSTED = 'exhausted',
}
export const phoneColumnRenderer = <RowType extends RowTypeBase>(
  row: RowType,
  column: Column<RowType>
): BodyCellRenderResult => {
  const fieldName = column.fieldName;
  const value = row[`${fieldName.charAt(0).toLowerCase()}${fieldName.slice(1)}` as keyof RowType];

  const statusColor: Record<string, string> = {
    [PhoneColumnStatus.INVALID]: 'error.main',
    [PhoneColumnStatus.VERIFIED]: 'success.main',
    [PhoneColumnStatus.BLACKLISTED]: 'common.black',
    [PhoneColumnStatus.CHECKING]: 'warning.main',
    [PhoneColumnStatus.DISCARDED]: '#800080',
    [PhoneColumnStatus.EXHAUSTED]: '#8B4513',
  };

  const status = row[`${fieldName.charAt(0).toLowerCase()}${fieldName.slice(1)}Status` as keyof RowType] as
    | PhoneColumnStatus
    | undefined;
  const dotColor = status ? statusColor[status] : 'transparent';

  const formattedValue =
    status !== PhoneColumnStatus.INVALID && value
      ? formatValue(value as string, column.format)
      : (value as string | undefined);
  return {
    node: (
      <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 }}>
        <Tooltip title={status ?? ''} placement="top">
          <Box
            component="span"
            sx={{
              width: 10,
              height: 10,
              borderRadius: '100%',
              backgroundColor: dotColor,
            }}
          />
        </Tooltip>
        <span>{formattedValue}</span>
      </Box>
    ),
    value: formattedValue,
  };
};
